import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

const domain = process.env.AUTH0_DOMAIN || process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.AUTH0_CLIENT_ID || process.env.REACT_APP_AUTH0_CLIENT_ID;

// Auth0 environment variables must be set for authentication to work

export function Auth0ProviderWithNavigate({ children }) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    // Store the last location before auth
    const lastPath = sessionStorage.getItem('lastPath') || '/';
    
    if (appState && appState.returnTo) {
      navigate(appState.returnTo, { replace: true });
    } else {
      navigate(lastPath, { replace: true });
    }
    
    // Clear the stored path
    sessionStorage.removeItem('lastPath');
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        // ALWAYS use current origin for redirect - don't rely on env vars which may be stale
        redirect_uri: window.location.origin,
        audience: process.env.AUTH0_AUDIENCE || process.env.REACT_APP_AUTH0_AUDIENCE
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
}
